var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyzeOnScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 817.61 595.07",
    id: "analyze-on-screen",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 380.87,
    x2: 382.9,
    y1: 393.72,
    y2: 538.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3f3d56",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 412.6,
    x2: 384.26,
    y1: 420.1,
    y2: -88.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 892.24,
    x2: 317.43,
    y1: -446.43,
    y2: 572.36,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 564.32,
    x2: 656.37,
    y1: 435.83,
    y2: 435.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 587.95,
    x2: 613.07,
    y1: 422.82,
    y2: 422.82,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 386.4,
    x2: 384.96,
    y1: 499.36,
    y2: 547.01,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 260.64,
    x2: -1.02,
    y1: 231.56,
    y2: 237.57,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 323.54,
    x2: 285.07,
    y1: 130.98,
    y2: 171.48,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 196,
    x2: 257.75,
    y1: 204.56,
    y2: 361.47,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 455.64,
    x2: 549,
    y1: 106.36,
    y2: 319.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 402.14,
    x2: 405.17,
    y1: 90.31,
    y2: 335.3,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 403.92,
    x2: 406.96,
    y1: 256.49,
    y2: 501.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 403.65,
    x2: 406.69,
    y1: 256.49,
    y2: 501.48,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 630,
    x2: 666.85,
    y1: 364.18,
    y2: 364.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#edcbd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 562.76,
    x2: 636.33,
    y1: 458.48,
    y2: 445.79,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 581.37,
    x2: 589.42,
    y1: 418.6,
    y2: 418.6,
    xlinkHref: "#d"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102.53,
    height: 8.71,
    x: 561.12,
    y: 586.36,
    fill: "#1d2741",
    opacity: 0.18,
    rx: 3.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M381.45 5.34c-31.33 9.69-59 28.31-85.92 47.05Q188.18 127.17 86.62 209.85c-23.17 18.85-46.47 38.42-62.45 63.67-28.49 45-29.9 103.28-14.09 154.13s47.08 95.42 80.89 136.55c7.31 8.89 15.09 17.92 25.49 22.83s22.58 5.17 34.2 4.82c66.31-2 131.16-19.15 197-27 102.2-12.23 205.55-2 308.44 1 39.23 1.13 81 .53 114.07-20.64s52-62.47 46.44-101.34c-4.83-33.87-26.06-63.27-34-96.55-10.38-43.47 2.74-89.34-3.22-133.64-8.59-64.55-57.46-118.02-114.59-149.2-46.84-25.59-100.09-39.71-152.35-49.29-43.27-7.92-87.33-23.36-131-9.85Z",
    opacity: 0.18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M294.42 402.55h175.05v136.14H294.42z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    style: {
      isolation: "isolate"
    },
    d: "M294.42 402.55h175.05v136.14H294.42z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M745.1 92.7v347.57a47.64 47.64 0 0 1-47.64 47.64H95.7a47.65 47.65 0 0 1-47.65-47.64V92.7A47.64 47.64 0 0 1 95.7 45.06h601.76A47.63 47.63 0 0 1 745.1 92.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M748.3 91.43V439a47.64 47.64 0 0 1-47.64 47.64H98.9a47.45 47.45 0 0 1-29-9.81 47.39 47.39 0 0 1-9.81-29V100.3a47.64 47.64 0 0 1 47.64-47.64h601.81a47.36 47.36 0 0 1 29 9.81 47.45 47.45 0 0 1 9.76 28.96Z",
    transform: "translate(-3.2 1.27)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M748.3 401.28V439a47.64 47.64 0 0 1-47.64 47.64H98.9A47.64 47.64 0 0 1 51.25 439v-37.72Z",
    transform: "translate(-3.2 1.27)",
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M656.35 427a144.14 144.14 0 0 1-4.72 38.5c-1.7 6.46-3.92 13-8.08 18.19a24.2 24.2 0 0 1-2.82 3h-68.27c2.77-12 6.64-27.06 5.28-28.83-6.18-8.08-8.54-18.37-10.68-28.32-1.79-8.33-3.53-16.88-2.36-25.33.14-1 .31-2 .51-2.89 2.91-13.34 24.74-16.13 34.12-16.26l8 16.26c0 7.86 33.84-20.89 39.77-14.58 3.4 3.62 5.54 8.85 6.89 14.58 2.01 8.68 2.27 18.59 2.36 25.68Z",
    opacity: 0.33,
    transform: "translate(-3.2 1.27)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m582.88 418.37-10.68-22.92a63.63 63.63 0 0 1 23.93-9.18 3.53 3.53 0 0 1 2.47.21 3.58 3.58 0 0 1 1.12 1.48c4.38 8.54 8.76 17.09 12.27 26 1.64 4.16 3.09 8.75 1.76 13-1.63 5.22-6.86 8.32-11.68 10.9-15.27 8.25-14.6-9.59-19.19-19.49Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M608.28 410.85c-3.18 5.26-5.27 11.1-8.17 16.52-.49.91-1.23 1.95-2.26 1.84a2.55 2.55 0 0 1-1.18-.54 62.08 62.08 0 0 1-8.72-7.21c0 5.89 3.59 11.11 7 15.92a2.61 2.61 0 0 0 .89.89 2.38 2.38 0 0 0 1 .17 21.8 21.8 0 0 0 11.32-3.08 1.3 1.3 0 0 0 .54-.47 1.43 1.43 0 0 0 .12-.74c-.11-5.75-.67-11.75 1.59-17 .69-1.62 1.64-3.13 2.19-4.81.36-1.11 1.08-4.67-.7-5.06-1.38-.35-3.04 2.61-3.62 3.57Z",
    opacity: 0.09,
    transform: "translate(-3.2 1.27)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M530.95 542.2a12.19 12.19 0 0 1-.84 4.49 12.45 12.45 0 0 1-11.65 8h-273a12.48 12.48 0 0 1-11.65-8 12.19 12.19 0 0 1-.84-4.49 12.48 12.48 0 0 1 12.49-12.49h273a12.49 12.49 0 0 1 12.49 12.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M534.15 540.93a12.19 12.19 0 0 1-.84 4.49 12.45 12.45 0 0 1-11.65 8h-273a12.48 12.48 0 0 1-11.65-8 12.19 12.19 0 0 1-.84-4.49 12.48 12.48 0 0 1 12.49-12.49h273a12.49 12.49 0 0 1 12.49 12.49Z",
    transform: "translate(-3.2 1.27)",
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M530.11 546.69a12.45 12.45 0 0 1-11.65 8h-273a12.48 12.48 0 0 1-11.65-8 12.24 12.24 0 0 1 2.82-4.35 12.45 12.45 0 0 1 8.83-3.66h273a12.48 12.48 0 0 1 11.65 8.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M156.29 232.77a54.35 54.35 0 0 0 51.71 54.3v27.08a81.42 81.42 0 0 1 0-162.76v27.08a54.35 54.35 0 0 0-51.71 54.3Z",
    transform: "translate(-3.2 1.27)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M292.08 232.77a81.25 81.25 0 0 1-29.27 62.53l-17.47-20.68a54.37 54.37 0 0 0-34.69-96.22c-.88 0-1.75 0-2.62.07v-27.08h2.62a81.43 81.43 0 0 1 81.43 81.38Z",
    transform: "translate(-3.2 1.27)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M262.81 295.3a81.08 81.08 0 0 1-52.16 18.9c-.88 0-1.75 0-2.62-.05v-27.08c.87 0 1.74.06 2.62.06a54.17 54.17 0 0 0 34.69-12.51Z",
    transform: "translate(-3.2 1.27)",
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M350.21 255.05h342.04v1.99H350.21z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M346.47 183.5s65.07-9.73 81.52-38.89 50.11-35.9 77 19.44 70.31 60.58 86 41.88 35.9-86 63.57-87.5 37.65 52.35 37.65 52.35v68.06h-342Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    style: {
      isolation: "isolate"
    },
    d: "M352.7 281.98h103.71v7.48H352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    style: {
      isolation: "isolate"
    },
    d: "M352.7 304.01h103.71v7.48H352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    style: {
      isolation: "isolate"
    },
    d: "M352.7 326.04h103.71v7.48H352.7z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M503.78 281.98h12.96v7.48h-12.96zM503.78 304.01h12.96v7.48h-12.96zM503.78 326.04h12.96v7.48h-12.96z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M630.06 362.15s12.67-23.93 21.47-22.17 17.6 10.91 14.78 17.95-17.41 20.07-17.86 26.4-11 3.52-11 3.52l-1.76-13.38s-6.34-5.63-5.63-12.32Z",
    transform: "translate(-3.2 1.27)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M649.53 335.61c2.6-.84 5.42-.47 8.08.1s5.55 1.47 7.46 3.5c2.71 2.88 2.92 7.25 4.51 10.88 1.37 3.14 3.83 5.82 4.59 9.16a11.45 11.45 0 0 1-1.55 8.37 17.46 17.46 0 0 1-6.3 5.89c-2.24 1.3-4.69 2.24-6.86 3.66s-3.85 3.16-5.87 4.61a10.48 10.48 0 0 1-6.93 2.33 4.35 4.35 0 0 1-2.61-1.09c-1.35-1.3-1.28-3.45-1.13-5.32q.3-3.39.58-6.79a11.55 11.55 0 0 0 4.06-.53 3.93 3.93 0 0 0 2.6-2.94c.27-2-1.77-3.77-3.81-4s-4 .67-5.86 1.53c-.78-1.61.37-3.46 1.52-4.84a56.52 56.52 0 0 1 5.26-5.46 4.39 4.39 0 0 0 1.48-1.92c.52-1.84-1.33-3.37-2.12-4.82a18 18 0 0 1-1.33-3.84c-1.12-3.82.18-7.18 4.23-8.48Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M659.96 461.52c-.5 3.31-1.13 6.69-2.81 9.59-5 8.59-16.73 9.87-26.67 9.66-4.81-.09-10.1-.55-14.16-2.84a12.48 12.48 0 0 1-4-3.42c-2.72-3.65-3-8.53-2.87-13.08.15-4.71.6-9.53.67-14.27.09-5.87-.42-11.62-2.82-16.91-1.31-2.9 4.46-13.33 5.67-16.28 1.95-4.73-4.1-1.78-2.15-6.51 2.15-5.21 4.43-10.6 8.65-14.3 6.54-5.7 16-6.05 24.7-6.1 1.4 0 3.34.64 3 2 6.67 1.83 10.23 12.6 11.57 19.37a154.77 154.77 0 0 1 1.22 53.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M626.94 476.21a36.75 36.75 0 0 1-7.42.45 12.48 12.48 0 0 1-4-3.42c-2.72-3.65-3-8.53-2.87-13.08.15-4.71.6-9.53.67-14.27l13.59-27.29s4.83 56.58.03 57.61Z",
    transform: "translate(-3.2 1.27)",
    style: {
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m640.23 480.33 10-2.85s2.77 2.89 0 14.24-3.64 90.28-3.64 90.28l-9-.05-8-73.34s-17.42 62.3-18.48 73.39h-10.65s3.72-99.35 11.89-107.49c0 0 4.83 2.36 27.88 5.82Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M607.57 415.74s-3.81 28.18-8.68 27.74-13.27-17.46-13.27-17.46a9.6 9.6 0 0 0-6.2 9.47c0 7.55 7.52 14.63 7.52 14.63s21.69 15.49 27.86 3.15 10.3-42.05 10.3-42.05 9.14-23-.07-21.43c-12.6 2.05-17.46 25.95-17.46 25.95Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M582.69 422.43a19.09 19.09 0 0 1-.44-12.72 3.08 3.08 0 0 1 1.25 1.67l2.7 6.13a12.62 12.62 0 0 0 2.33-2.72 1.86 1.86 0 0 1 .87 1.95 12.29 12.29 0 0 1-.7 2.18 13.41 13.41 0 0 0-.08 5.95 20.61 20.61 0 0 1-2.13 1.7c-.64.44-1.48 1.28-2 .73s-.57-1.94-.83-2.56-.66-1.53-.97-2.31Z",
    transform: "translate(-3.2 1.27)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m611.02 582-1.32 10.6h-23.76s1.59-7.43 14.52-10.6ZM646.96 582l.84 10.6h-25.92s1.58-7.43 14.52-10.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeOnScreen);
export default __webpack_public_path__ + "static/media/analyze-on-screen.d37a54bd3fb6317003a2eb57d33e5e82.svg";
export { ForwardRef as ReactComponent };